export default {
  "content": "<path fill=\"#707070\" d=\"M.417.167L5 4.75 9.584.167H.417z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "10",
    "height": "5",
    "fill": "none",
    "viewBox": "0 0 10 5"
  }
};